var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("tooltip--transition--" + (_vm.animation || _vm.direction)),"mode":"out-in"}},[_c('span',{staticClass:"tooltip position--absolute background--green color--white",class:[
            ("tooltip--" + _vm.direction),
            ( _obj = {}, _obj[("tooltip--" + _vm.direction + "--" + _vm.arrow)] = _vm.arrow, _obj ),
            { 'tooltip--hover': _vm.hover } ]})])}
var staticRenderFns = []

export { render, staticRenderFns }